// src/components/sacred/MaghribiHeading.jsx
// Aref-Ruqaa display heading with optional saffron glow.

import React from 'react';
import { Typography } from '@mui/material';

const variantMap = {
  display: 'h1',
  headline: 'h2',
  title: 'h3',
  section: 'h4',
};

const MaghribiHeading = ({
  children,
  variant = 'headline',
  glow = false,
  tone = 'primary',
  component,
  sx = {},
  ...rest
}) => {
  const colorFn = (t) => {
    if (tone === 'secondary') return t.palette.sacred.secondary;
    if (tone === 'onPrimary') return t.palette.sacred.onPrimary;
    if (tone === 'ink') return t.palette.sacred.ink;
    return t.palette.sacred.primary;
  };
  return (
    <Typography
      variant={variantMap[variant] || 'h2'}
      component={component || variantMap[variant] || 'h2'}
      className={glow ? 'maghribi-glow' : undefined}
      sx={(t) => ({
        fontFamily: 'var(--sacred-font-display)',
        color: colorFn(t),
        fontWeight: 700,
        lineHeight: 1.2,
        ...sx,
      })}
      {...rest}
    >
      {children}
    </Typography>
  );
};

export default MaghribiHeading;
